import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { CollapseBlock, Spinner } from '../../../../../common/index.jsx';
import { useGetDateParticipantsQuery } from '../../../../../../redux/services/fo_dates.jsx';
import FoDateParticipantsTable from './FoDateParticipantsTable.jsx';

const FoDateParticipantsPage = () => {
  const { t } = useTranslation();
  const { dateId } = useParams();

  const { data, isLoading } = useGetDateParticipantsQuery(dateId);
  const participants = Array.isArray(data?.participants) ? data.participants : [];

  return (
    <>
      <AppBarCMS
        title={t('Účastníci termínu')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
        permissionsBasic={'fo-dates'}
      />

      {isLoading ? (
        <Spinner />
      ) : (
        <div style={{ margin: '10px' }}>
          <CollapseBlock title={t('Zoznam účastníkov termínu')}>
            <FoDateParticipantsTable participants={participants} />
          </CollapseBlock>
        </div>
      )}
    </>
  );
};

export default FoDateParticipantsPage;

